// src/pages/DataDeletionPage.js
import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Box,
  Container,
  Typography,
  Toolbar,
  Paper
} from '@mui/material';
import PublicHeader from '../components/PublicHeader';
import Footer from '../components/Footer';
import SEO from '../components/SEO';

const DataDeletionPage = () => {
  const { t } = useTranslation('legal');

  const dataDeletionBreadcrumb = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      { "@type": "ListItem", "position": 1, "name": "首頁", "item": "https://rebaz.ai" },
      { "@type": "ListItem", "position": 2, "name": t('dataDeletion.title'), "item": "https://rebaz.ai/data-deletion" }
    ]
  };

  return (
    <>
      <SEO
        title={t('dataDeletion.title')}
        description={t('dataDeletion.description')}
        canonicalUrl="https://rebaz.ai/data-deletion"
        breadcrumb={dataDeletionBreadcrumb}
      />
      <Box sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh'
      }}>
        {/* Header */}
        <PublicHeader />
        <Toolbar />

        {/* Main Content */}
        <Box component="main" sx={{ flexGrow: 1, py: 6, backgroundColor: '#f5f5f5' }}>
          <Container maxWidth="md">
            <Paper elevation={2} sx={{ p: { xs: 3, md: 5 }, borderRadius: 2 }}>
              <Typography variant="h3" component="h1" fontWeight="bold" gutterBottom>
                {t('dataDeletion.title')}
              </Typography>

              <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
                {t('dataDeletion.lastUpdated')}
              </Typography>

              {/* Section 1: Introduction */}
              <Typography variant="h5" component="h2" fontWeight="bold" sx={{ mt: 4, mb: 2 }}>
                {t('dataDeletion.sections.introduction.title')}
              </Typography>
              <Typography variant="body1" paragraph>
                {t('dataDeletion.sections.introduction.content')}
              </Typography>

              {/* Section 2: Data We Store */}
              <Typography variant="h5" component="h2" fontWeight="bold" sx={{ mt: 4, mb: 2 }}>
                {t('dataDeletion.sections.dataWeStore.title')}
              </Typography>
              <Typography variant="body1" paragraph>
                {t('dataDeletion.sections.dataWeStore.content')}
              </Typography>

              {/* Section 3: How to Request Deletion */}
              <Typography variant="h5" component="h2" fontWeight="bold" sx={{ mt: 4, mb: 2 }}>
                {t('dataDeletion.sections.howToRequest.title')}
              </Typography>
              <Typography variant="body1" paragraph>
                {t('dataDeletion.sections.howToRequest.content')}
              </Typography>

              {/* Section 4: Deletion Process */}
              <Typography variant="h5" component="h2" fontWeight="bold" sx={{ mt: 4, mb: 2 }}>
                {t('dataDeletion.sections.deletionProcess.title')}
              </Typography>
              <Typography variant="body1" paragraph>
                {t('dataDeletion.sections.deletionProcess.content')}
              </Typography>

              {/* Section 5: Data Retention */}
              <Typography variant="h5" component="h2" fontWeight="bold" sx={{ mt: 4, mb: 2 }}>
                {t('dataDeletion.sections.dataRetention.title')}
              </Typography>
              <Typography variant="body1" paragraph>
                {t('dataDeletion.sections.dataRetention.content')}
              </Typography>

              {/* Section 6: Facebook/Instagram Data */}
              <Typography variant="h5" component="h2" fontWeight="bold" sx={{ mt: 4, mb: 2 }}>
                {t('dataDeletion.sections.metaPlatformData.title')}
              </Typography>
              <Typography variant="body1" paragraph>
                {t('dataDeletion.sections.metaPlatformData.content')}
              </Typography>

              {/* Section 7: Contact */}
              <Typography variant="h5" component="h2" fontWeight="bold" sx={{ mt: 4, mb: 2 }}>
                {t('dataDeletion.sections.contact.title')}
              </Typography>
              <Typography variant="body1" paragraph>
                {t('dataDeletion.sections.contact.content')}
              </Typography>
              <Typography variant="body1">
                Email: service@rebaz.ai
              </Typography>
            </Paper>
          </Container>
        </Box>

        {/* Footer */}
        <Footer />
      </Box>
    </>
  );
};

export default DataDeletionPage;
